import React from "react";
import "./header-nav.scss";

import { setPromoCode } from "../../../../store/siteSlice";
import { useDispatch } from "react-redux";
import IconProviders from "../../../mui/JSXIcons/IconProviders";
import IconHit from "../../../mui/JSXIcons/IconHit";
import IconBonus from "../../../mui/JSXIcons/IconBonus";
import IconPromo from "../../../mui/JSXIcons/IconPromo";
import { useTranslation } from "react-i18next";
import useLoginAction from "../../../../hooks/useLoginAction";
import { Link } from "react-router-dom";
import useGetLink from "../../../../hooks/other/useGetLink";
import { useAppSelector } from "../../../../store/index.ts";

export default function HeaderNav() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { onLoginAction } = useLoginAction();
  const isTgBot = useAppSelector((state) => state.common.isTgBot);
  const isBonusProvider = useAppSelector((state) => state.games.bonusProvider?.id);

  const hitLink = useGetLink("/games/hit");
  const bonusLink = useGetLink("/games/bonus");
  const promoLink = useGetLink("/promotions");

  const navList = [
    // { title: "Providers", img: <IconProviders />, link: "/games/providers" },
    { title: "Hit", img: <IconHit />, link: hitLink },
    { title: "Bonus games", img: <IconBonus />, link: bonusLink },
    {
      title: "Promo",
      className: "promo",
      img: <IconPromo />,
      onClick: () => onLoginAction(() => dispatch(setPromoCode(true)))
    },
    { title: "Promotions", img: <IconProviders />, link: promoLink }
  ];

  if (isTgBot) delete navList[3];
  if (!isBonusProvider) delete navList[1];

  return (
    <nav className="header__nav">
      {navList.map((item, indx) => (
        <button className={item.className || ""} key={indx} onClick={item?.onClick}>
          {item.img}

          {item.link ? <Link to={item.link}>{t(item.title)}</Link> : <span>{t(item.title)}</span>}
        </button>
      ))}
    </nav>
  );
}
